const carouselItems = [
  {
    title: '2024夏季新番导览',
    desc: '盘点本季最值得期待的30部新番，从热门续作到黑马新作一网打尽',
    tag: '新番专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20collage%20style%20illustration%20with%20multiple%20colorful%20anime%20character%20silhouettes%2C%20summer%20theme%20with%20warm%20sunlight%20and%20blue%20sky%2C%20dynamic%20composition%2C%20clean%20flat%20illustration%20style%2C%20festive%20atmosphere%2C%20no%20text%20no%20watermark&width=560&height=340&seq=carousel-01&orientation=landscape',
  },
  {
    title: '国漫崛起·精品推荐',
    desc: '从时光代理人到雾山五行，国产动画精品力作深度盘点',
    tag: '国漫专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20style%20illustration%20with%20traditional%20ink%20painting%20elements%20blended%20with%20modern%20anime%20style%2C%20dramatic%20martial%20arts%20poses%2C%20elegant%20flowing%20fabric%2C%20warm%20earthy%20color%20palette%2C%20cinematic%20composition%2C%20no%20text%20no%20watermark&width=560&height=340&seq=carousel-02&orientation=landscape',
  },
  {
    title: '经典番剧重温指南',
    desc: '那些年我们追过的神作，值得二刷三刷的经典动漫合集',
    tag: '怀旧专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%20anime%20illustration%20with%20warm%20golden%20retro%20color%20palette%2C%20classic%20anime%20style%20characters%20from%20different%20eras%2C%20film%20grain%20texture%20overlay%2C%20sentimental%20atmosphere%2C%20clean%20flat%20vintage%20aesthetic%2C%20no%20text%20no%20watermark&width=560&height=340&seq=carousel-03&orientation=landscape',
  },
  {
    title: '热血战斗动漫大全',
    desc: '燃到爆炸！从鬼灭到咒术，最全热血战斗番剧推荐清单',
    tag: '燃向专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20anime%20illustration%20with%20explosive%20energy%20effects%2C%20silhouettes%20of%20fighting%20characters%20with%20glowing%20energy%20auras%2C%20dramatic%20red%20and%20orange%20color%20scheme%2C%20intense%20cinematic%20lighting%2C%20clean%20flat%20animation%20style%2C%20no%20text%20no%20watermark&width=560&height=340&seq=carousel-04&orientation=landscape',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">专题推荐</h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-10">精心策划的动漫专题，发现更多精彩内容</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <div key={i} className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer">
              <div className="relative aspect-[5/3] bg-background-200 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 rounded-md text-xs font-semibold">{item.tag}</span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}